/**
 * Vue Router Configuration — Donor Portal
 *
 * Authenticated pages are nested inside AppLayout so they render
 * with the header, sidebar, and footer chrome.  Public pages
 * (login, health-check, not-found) bypass the layout entirely.
 */
import type { RouteRecordRaw } from 'vue-router';
import AppLayout from '@/shared/components/layout/AppLayout.vue';
import { dashboardRoutes } from '@/modules/dashboard';
import { myProfileRoutes } from '@/modules/my-profile';
import { impactRoutes } from '@/modules/impact';
import { authRoutes } from '@/modules/auth';

export const routes: RouteRecordRaw[] = [
  // Authenticated pages — wrapped in AppLayout
  {
    path: '/',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/dashboard' },
      ...dashboardRoutes,
      ...myProfileRoutes,
      ...impactRoutes,
    ],
  },

  // Auth pages — no layout chrome
  ...authRoutes,

  {
    path: '/healthcheck',
    name: 'health-check',
    component: () => import('../views/HealthCheckView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Health Check',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue'),
  },
];
